import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './local';
import './i18n';
import './portal.css';
import 'mobily-ui-library/fonts.css';
import 'mobily-ui-library/style.css';

import App from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
